module.exports = __webpack_public_path__ + "static/media/triplebombshellbetties.3aac4ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/triplebombshellbetties.png
// module id = 1373
// module chunks = 1